import * as api from "../../apis/consignOrder";
import * as categoryApi from "../../apis/productCategory";
import {ComponentProps, useState} from "react";
import PageHeaderLayout from "../../layout/pageHeaderLayout";
import useAntTable from "../../utils/useAntTable";
import StandardTable, {StandardColumnsType} from "../../components/StandardTable";
import dayjs from "dayjs";
import {Button, Space} from "antd";

function ConsignOrderLine(props:ComponentProps<any>){

    const [categories, setCategories] = useState<Array<any>>([]);

    const {tableProps, download, downloading, search, form} = useAntTable(api.getOrderLines , {method: 'post', downloadUrl: api.exportOrderLinesUrl})

    const columns:StandardColumnsType = [
        {
            dataIndex: 'code',
            title: '寄售申请单号'
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称'
        },
        {
            dataIndex: 'hospitalFullName',
            title: '终端医院'
        },
        {
            dataIndex: 'productCode',
            title: '商品编码'
        },
        {
            dataIndex: 'productName',
            title: '商品名称'
        },
        {
            dataIndex: 'method',
            key: 'method',
            title: '方法',
            width: 100,
        },
        {
            dataIndex: 'useIn',
            key: 'useIn',
            title: '适用机型',
            width: 100,
        },
        {
            dataIndex: 'qty',
            title: '寄售申请数量'
        },
        {
            dataIndex: 'qtyOfOrderNotPlaced',
            title: '未下单数量'
        },
        {
            dataIndex: 'orderDate',
            title: '订单日期',
            render(v){
                return v && dayjs(v).format('ll')
            }
        }
    ];

    const searchColumns:StandardColumnsType =[
        {
            dataIndex: 'code',
            title: '单号',
            search: true
        },
        {
            dataIndex: 'dealerName',
            title: '客户名称',
            search: true
        },
        {
            dataIndex: 'productCode',
            title: '商品编码',
            search: true
        },
        {
            dataIndex: 'businessMan',
            title: '商务人员',
            search: true
        },
        {
            dataIndex: 'productName',
            title: '商品名称',
            search: true
        },
        {
            dataIndex: 'contractCode',
            title: '合同号',
            search: true
        },
        {
            dataIndex: 'hospitalName',
            title: '终端医院',
            search: true
        },
        {
            dataIndex: 'orderDateRange',
            title: '订单日期',
            search: {
                valueType: 'dateRange'
            }
        }

    ];

    const toolbar = (
        <Space>
            <Button type={"primary"} onClick={download} loading={downloading}>导出Excel</Button>
        </Space>
    )

    return <PageHeaderLayout>
            <StandardTable {...tableProps} columns={columns} extSearchColumns={searchColumns} form={form} search={search} submit={search.submit} toolbar={toolbar}/>
    </PageHeaderLayout>
}

export default ConsignOrderLine;